var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gameBox"},[_c('div',{staticClass:"txt"},[_vm._v(" "+_vm._s(_vm.$t('矿机板块建设中'))+"~ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }